<template>
    <div class="content limit-max daily">
        <Loading v-if="loading"/>
        <template v-else>
            <Ques
                :questions="questions"
                @submit="handleSubmit"
            />
        </template>
    </div>
</template>

<script>
import { Loading } from 'vant';
import { objToList, arrRenameKey } from '@/utils/func';
import { cacQuizsGet, cacQuizResultsPost } from '@/apis/cac';
import Ques from './components/Ques'
// import Analysis from './components/Analysis'
export default {
    components: {
        Ques,
        // Analysis,
        Loading
    },
    data() {
        return {
            maxDailyTime: 0,
            loading: true,
            questions:[],
            userResult: {},
            results:[]
        };
    },
    async mounted() {
        this.getQues()
    },
    methods: {
        async getQues() {
            try {
                const {body} = await cacQuizsGet({
                    params: {
                        limit: 10
                    }
                })
                this.questions = body
                this.loading = false
            } catch (error) {
                console.log(error)
                this.loading = false
                this.location.replace('/quiz')
            }
        },
        async handleSubmit(answers) {
            try {
                const {
                    body
                } = await cacQuizResultsPost({
                    body: {
                        user_quizs: arrRenameKey(objToList(answers, 'quiz_id', (val) => parseInt(val)), {seq_id: 'answer_seq_num'})
                    }
                })

                // 跳转至结果页
                this.location.replace(`/cac/result/${body.result_id}`)
            } catch (error) {
                console.log(error)
                this.location.replace('/cac')
            }
        },
    }
};
</script>
<style lang="less">
.daily{
    &.limit-max {
        @media screen and (min-width: 750px) {
            .scroll-content {
                border-width: 7rem;
                background-size: calc(100% + 14rem) calc(100% + 16vh);
            }
        }
    }
    .content-wrap {
        background-image: url(http://guokrapp-static.guokr.com/Fudvr7yllh2kcXonhok25xlKb3D6);
        background-position: bottom center;
    }
    /deep/.van-loading {
        text-align: center;
    }
    .scroll-content{
        margin-top: 15%;
    }
    .p2 {
        position: absolute;
        bottom: 0;
        left: 4%;
        width: 15%;
    }
}
</style>
